import { Fragment, Suspense } from 'react';
import './App.css';

import { Layout } from '@flexisaf/flexibull2';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { Lazy, Loadable } from 'utils/ComponentLoader';
import { Theme } from 'config/theme';
import { StyledLayout } from 'style';
import PrivateRoute from 'routes/PrivateRoute';
import PermissionRoute from 'routes/PermissionRoute';
import AdminLayout from 'pages/AdminLayout';
import GroupLayout from 'pages/GroupLayout';

// O P E N    R O U T E S
const LoginPage = Loadable(() => import('pages/Login'));
const ConfirmPasswordReset = Loadable(() => import('pages/auth/ConfirmPasswordReset'));
const Unauthorized = Loadable(() => import('pages/error-pages/Unauthorized'));

// G U A R D E D    R O U T E S
const Dashboard = Lazy(() => import('pages/emis-dashboard/index'));

function App() {
  return (
    <>
      <Fragment>
        <StyledLayout>
          <Layout theme={Theme}>
            <Router>
              <Routes>
                <Route path="/unauthorized" element={<Unauthorized />} />
                <Route path="/:groupURL" element={<GroupLayout />}>
                  <Route path="" element={<LoginPage />} />
                  <Route path="unauthorized" element={<Unauthorized />} />
                  <Route path="login" element={<LoginPage />} />
                  <Route path="confirm" element={<ConfirmPasswordReset />} />

                  <Route
                    path=""
                    element={
                      <PrivateRoute>
                        <AdminLayout />
                      </PrivateRoute>
                    }
                  >
                    <Route
                      path="dashboard"
                      element={
                        <PermissionRoute
                          permission={true}
                          component={
                            <Suspense>
                              <Dashboard />
                            </Suspense>
                          }
                        />
                      }
                    />
                  </Route>
                </Route>
              </Routes>
            </Router>
          </Layout>
        </StyledLayout>
      </Fragment>
    </>
  );
}

export default App;
